export default __webpack_public_path__ + "static/media/birchwood-university.d416926f.webp";